import { IconBase, type IconProps } from './IconBase';

/**
 * EstrellaIcon — estrella de 8 puntas (estilo sello mistico).
 *
 * Simbolo: rating, destacado, sello sagrado.
 *
 * Composicion:
 * - Dos cuadrados superpuestos rotados 45 grados entre si: octagrama
 *   regular (estrella de 8 puntas). Es un simbolo recurrente en arte
 *   sacro y herbolaria mediterranea.
 * - Pequeno circulo central que actua como sello/punto focal.
 *
 * Las coordenadas se calculan sobre el centro (12,12) con radio 9
 * para mantener margen visual dentro del viewBox 24x24.
 */
export function EstrellaIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      {/* Cuadrado 1 (ortogonal): vertices arriba/derecha/abajo/izquierda */}
      <path d="M12 3 L21 12 L12 21 L3 12 Z" />
      {/* Cuadrado 2 (rotado 45): vertices en las diagonales */}
      <path d="M5.6 5.6 L18.4 5.6 L18.4 18.4 L5.6 18.4 Z" />
      {/* Sello central */}
      <circle cx="12" cy="12" r="1" />
    </IconBase>
  );
}
